<template>
  <div>
    <navlist :navlist="about" />
    <div class="layout">
      <div class="title">
        <h1>
          社区
          <br />安全
        </h1>
        <h2></h2>
      </div>
      <div class="main nomargin">
        <Waterfall
          :list="list"
          :gutter="10"
          :width="400"
          :phoneCol="2"
          backgroundColor="transparent"
          ref="waterfall"
        >
          <template slot="item" slot-scope="props">
            <div class="card">
              <div class="cover">
                <img
                  :src="'/static/uploads/'+props.data.img"
                  alt
                  @load="$refs.waterfall.refresh()"
                  preview
                  :preview-text="props.data.content"
                />
              </div>
              <div class="name">
                <p>{{props.data.content}}</p>
              </div>
            </div>
          </template>
        </Waterfall>
      </div>
    </div>
  </div>
</template>

<script>
import Waterfall from "vue-waterfall-plugin";
import navlist from "../components/nav";
import {getImgAndDesc} from '../api/index'
export default {
  components: {
    navlist,
    Waterfall
  },
  data() {
    return {
      about: [
        {
          path: "/security",
          name: "社区安全"
        }
      ],
      list: [
        {
          src: require(`../assets/images/safe/1.jpg`),
          name: `111`
        },
        {
          src: require(`../assets/images/about/img2.jpg`),
          name: `111`
        },
        {
          src: require(`../assets/images/safe/1.jpg`),
          name: `111`
        },
        {
          src: require(`../assets/images/about/img2.jpg`),
          name: `111`
        },
        {
          src: require(`../assets/images/safe/1.jpg`),
          name: `111`
        },
        {
          src: require(`../assets/images/about/img2.jpg`),
          name: `111`
        },
        {
          src: require(`../assets/images/safe/1.jpg`),
          name: `111`
        }
      ],
      action: 'safe',
      page: 1
    };
  },
  methods:{
    async getlist(){
      let {action} = this
      let { data } = await getImgAndDesc({action})
     
      this.list = data.data
    }
  },
  created(){
    this.getlist()
  }
};
</script>

<style>
.grid {
  height: 100%;
  width: 100%;
  background: transparent;
}
.grid-item {
  opacity: 1 !important;
}
.grid-item img {
  width: 100%;
}
.nomargin {
  margin-top: 0 !important;
  overflow-y: scroll;
}
.grid-item .name{
  font-size: 24px;
}
</style>